import { DocumentHistoryEntry } from "@/atoms/documentHistory";

export class DocumentHistoryStore {
  static load(userId: string): DocumentHistoryEntry[] {
    try {
      const raw = localStorage.getItem(`document-history-${userId}`);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch {
      return [];
    }
  }

  static save(userId: string, entries: DocumentHistoryEntry[]): void {
    localStorage.setItem(`document-history-${userId}`, JSON.stringify(entries));
  }
}
